import { ArticleModel } from './article.model';
import { InvoiceService } from '../services/invoice.service';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { Estate } from '../utils/enum.util';

export class InvoiceModel {

    private _errors: any;
    private _clientPrivateId: string;
    private _publicId: string;
    private _privateId: string;
    private _where: string              = 'Aubonne';
    private _whenDay: number;
    private _whenMonth: number;
    private _whenYear: number;
    private _tva: number                = 0.08;
    private _infoClientName: string;
    private _infoClientAdress: string;
    private _articles: ArticleModel[]   = [];
    private _info: string               = '';
    private _subTotal: number;
    private _nbHourWorkForce: number    = null;
    private _priceHourWorkForce: number = 100;
    private _shippingPrice: number      = null;
    private _discount: number           = null;
    private _advance: number            = null;
    private _total: string;
    private _subTotal2: string;
    private _magasin: string        = null;
    private _tvaValue: string;
    private _discount2: number;
    private _useless: boolean           = false;
    private _state: Estate              = Estate.Saving;
    private _archive: boolean = false;
    private _paid:any = null;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public invoiceService: InvoiceService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************

    save(): boolean {
        if (this.validate() && this.validateArticles()) {
            this.state = Estate.Saving;
            if (this.privateId == undefined){
                this.invoiceService.create(this);
            } else {
                this.invoiceService.update(this);
            }
            return true;
        } else {
            this.state = Estate.Error;
            return false;
        }
    }

    modelChange(_value) {
        this.save();
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this._whenDay, 'whenDay', EvalidatorRequire.Require, [
                {fn: validator.integer, options: {min: 1, max: 31}}
            ])
            .addField(this._whenMonth, 'whenMonth', EvalidatorRequire.Require, [
                {fn: validator.integer, options: {min: 1, max: 12}}
            ])
            .addField(this._whenYear, 'whenYear', EvalidatorRequire.Require, [
                {fn: validator.integer, options: {min: 1950, max: 2100}}
            ])
            .addField(this._advance, 'advance', EvalidatorRequire.Optional, [
                {fn: validator.double, options: {min: 0, max: 100000}}
            ])
            .addField(this._discount, 'discount', EvalidatorRequire.Optional, [
                {fn: validator.double, options: {min: 0, max: 100000}}
            ])
            .addField(this._shippingPrice, 'shippingPrice', EvalidatorRequire.Optional, [
                {fn: validator.double, options: {min: 0, max: 100000}}
            ])
            .addField(this._nbHourWorkForce, 'workForce', EvalidatorRequire.Optional, [
                {fn: validator.double, options: {min: 0, max: 100000}}
            ])
            .addField(this._magasin, 'magasin', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 20}}
            ])
            .addField(this._priceHourWorkForce, 'workForce', EvalidatorRequire.Require, [
                {fn: validator.double, options: {min: 0, max: 100000}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    public validateArticles(): boolean {
        let isValide = true;
        this.articles.forEach((article: ArticleModel)=> {
            if (!article.validate())
                isValide = false;
        });
        return isValide;
    }

    //*************************************
    //************** METHOD ***************
    //*************************************
    generatePublicId() {
        let date      = new Date();
        this.publicId = 'F.' +
            date.getFullYear().toString().slice(-2) +
            ('0' + ((date.getMonth() + 1).toString())).slice(-2) +
            ('0' + (date.getDate().toString())).slice(-2) +
            '-' +
            ('0' + (date.getHours().toString())).slice(-2) +
            ('0' + (date.getMinutes().toString())).slice(-2);
    }

    calculateValue() {
        this.subTotal  = 0;
        this.discount2 = 0;

        this.articles.forEach(e=> {
            this.subTotal += e.price * e.quantity;
            if (e.free)
                this.discount2 += e.price * e.quantity;
        });

        this.subTotal2 = this.doubleToString(this.subTotal + (this.nbHourWorkForce * this.priceHourWorkForce) + this.shippingPrice);
        this.total     = this.doubleToString((this.subTotal + (this.nbHourWorkForce * this.priceHourWorkForce) + this.shippingPrice) - this.discount - this.advance - this.discount2);
    }

    doubleToString(value: number) {
        if (value)
            return value.toFixed(2);
    }

    addArticle() {
        this.state = Estate.Error;
        this.articles.push(new ArticleModel(this));
    }

    addPack(listArticles: ArticleModel[]) {
        this.state = Estate.Error;
        listArticles.forEach((article)=> {
            let articleCopy      = new ArticleModel(this);
            articleCopy.free     = article.free;
            articleCopy.quantity = article.quantity;
            articleCopy.about    = article.about;
            articleCopy.price    = article.price;
            articleCopy.type     = article.type;
            articleCopy.validate();
            this.articles.push(articleCopy);
        });
        this.save();
    }

    public delete() {
        this.invoiceService.delete(this, 'delete');
    }

    public archiver() {
        this.invoiceService.delete(this, 'archive');
    }

    public unarchiver(){
        this.invoiceService.delete(this, 'unarchive');
    }

    setWhen(when){
        when = when.split('-');
        if (when.length == 3) {
            this.whenDay   = Number(when[2]);
            this.whenMonth = Number(when[1]);
            this.whenYear  = Number(when[0]);
        } else {
            this.whenDay   = null;
            this.whenMonth = null;
            this.whenYear  = null;
        }
    }

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************

    get clientPrivateId(): string {
        return this._clientPrivateId;
    }

    set clientPrivateId(value: string) {
        this._clientPrivateId = value;
    }

    get publicId(): string {
        return this._publicId;
    }

    get magasin(): string {
        return this._magasin;
    }

    set magasin(value: string) {
        this._magasin = value;
    }

    set publicId(value: string) {
        this._publicId = value;
    }

    get privateId(): string {
        return this._privateId;
    }

    set privateId(value: string) {
        this._privateId = value;
    }

    get where(): string {
        return this._where;
    }

    set where(value: string) {
        this._where = value;
    }

    get whenDay(): number {
        return this._whenDay;
    }

    set whenDay(value: number) {
        this._whenDay = value;
    }

    get whenMonth(): number {
        return this._whenMonth;
    }

    set whenMonth(value: number) {
        this._whenMonth = value;
    }

    get whenYear(): number {
        return this._whenYear;
    }

    set whenYear(value: number) {
        this._whenYear = value;
    }

    get tva(): number {
        return this._tva;
    }

    set tva(value: number) {
        this._tva = value;
    }

    get articles(): ArticleModel[] {
        return this._articles;
    }

    set articles(value: ArticleModel[]) {
        this._articles = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get info(): string {
        return this._info;
    }

    set info(value: string) {
        this._info = value;
    }

    get subTotal(): number {
        return this._subTotal;
    }

    set subTotal(value: number) {
        this._subTotal = value;
    }

    get nbHourWorkForce(): number {
        return this._nbHourWorkForce;
    }

    set nbHourWorkForce(value: number) {
        this._nbHourWorkForce = value;
    }

    get priceHourWorkForce(): number {
        return this._priceHourWorkForce;
    }

    set priceHourWorkForce(value: number) {
        this._priceHourWorkForce = value;
    }

    get shippingPrice(): number {
        return this._shippingPrice;
    }

    set shippingPrice(value: number) {
        this._shippingPrice = value;
    }

    get discount(): number {
        return this._discount;
    }

    set discount(value: number) {
        this._discount = value;
    }

    get advance(): number {
        return this._advance;
    }

    set advance(value: number) {
        this._advance = value;
    }

    get total(): string {
        return this._total;
    }

    set total(value: string) {
        this._total = value;
    }

    get subTotal2(): string {
        return this._subTotal2;
    }

    set subTotal2(value: string) {
        this._subTotal2 = value;
    }

    get tvaValue(): string {
        return this._tvaValue;
    }

    get archive(): boolean {
        return this._archive;
    }

    set archive(value: boolean) {
        this._archive = value;
    }

    set tvaValue(value: string) {
        this._tvaValue = value;
    }

    get discount2(): number {
        return this._discount2;
    }

    set discount2(value: number) {
        this._discount2 = value;
    }

    get useless(): boolean {
        return this._useless;
    }

    set useless(value: boolean) {
        this._useless = value;
    }

    get infoClientName(): string {
        return this._infoClientName;
    }

    set infoClientName(value: string) {
        this._infoClientName = value;
    }

    get infoClientAdress(): string {
        return this._infoClientAdress;
    }

    set infoClientAdress(value: string) {
        this._infoClientAdress = value;
    }

    get state(): Estate {
        return this._state;
    }

    set state(value: Estate) {
        this._state = value;
    }

    get paid(): any {
        return this._paid;
    }

    set paid(value: any) {
        this._paid = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/invoice.model.ts